import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useGetSectors } from '@/hooks/v1';
import type { InputDefaultProps } from '../../../types';
import { FormItem } from '@/components/ui/Inputs/FormItem';
import { SectorSelect } from '@/components/ui/Inputs/SectorSelect';

const { useFormInstance, useWatch } = Form;

export function Sector({
	fieldName,
	fontSize = '1rem',
	disabled = false,
	isRequired = false
}: Readonly<InputDefaultProps>) {
	const form = useFormInstance();

	const organizationId = useWatch([fieldName, 'organization_id'], form);
	const companyId = useWatch([fieldName, 'company_id'], form);
	const sectorId = useWatch([fieldName, 'sector_id'], form);

	const { data: sectors, isLoading, isFetching, isError } = useGetSectors(organizationId, companyId);

	function handleSectorSelect(id: string) {
		form.setFieldValue([fieldName, 'sector_id'], id);
		handleClearHierarchy();
	}

	function handleClearSector() {
		form.setFieldValue([fieldName, 'sector_id'], undefined);
		handleClearHierarchy();
	}

	function handleClearHierarchy() {
		form.setFieldValue([fieldName, 'line_id'], undefined);
		form.setFieldValue([fieldName, 'activity_id'], undefined);
		form.setFieldValue([fieldName, 'workstation_id'], undefined);
	}

	return (
		<Col span={24}>
			<FormItem
				title={I18n.get('Sector')}
				fontSize={fontSize}
				isRequired={isRequired}
				errorMessage={I18n.get('Select a sector')}
				namePath={[fieldName, 'sector_id']}
			>
				<SectorSelect
					size="large"
					allowCreation
					sectors={sectors}
					sectorId={sectorId}
					loading={isFetching}
					fieldName={[fieldName, 'sector_id']}
					handleClearSector={handleClearSector}
					handleSelectSector={handleSectorSelect}
					disabled={disabled || isLoading || isFetching || isError || (!companyId && fieldName !== 'filter')}
				/>
			</FormItem>
		</Col>
	);
}
